








































    import {Vue, Component} from "vue-property-decorator";
    import axios from 'axios';
    import {MutationList as modalMutations, MutationList as ModalMutations} from "@/store/modules/modal/mutation-list";
    import {doctorListType, doctorType, servicesListType, serviceType} from "@/types";

    @Component
    export default class ModalServicesList extends Vue {

        private servicesList: servicesListType[] = [];
        private doctorsList: doctorListType[] = [];
        private modalNamespace = 'modal/';

        private showDoctors = false;
        private showServices = true;

        private servicesFilterText = '';
        private doctorsFilterText = '';

        private doctorsListFiltered: doctorListType[] = [];
        private servicesListFiltered: servicesListType[] = [];

        // TODO - do something with loading modal appearance
        async fetchData() {
            this.$store.commit(`${this.modalNamespace}${modalMutations.SELECT_LOADING_MODAL}`, 'search all information');
            await axios.get('https://dev.palmamedical.lv/api/rest/services/list')
                .then(response => {
                    this.servicesList = response.data;
                    this.$store.commit(`${this.modalNamespace}${modalMutations.SET_MODAL_VISIBILITY_FALSE}`);
                })
                .catch(e => {
                    this.$store.commit(`${this.modalNamespace}${modalMutations.SELECT_MESSAGING_MODAL}`, {
                        header: 'an error happened',
                        message: e
                    });
                });
            await axios.get('https://dev.palmamedical.lv/api/rest/doctors/list')
                .then(response => {
                    this.doctorsList = response.data;
                    this.$store.commit(`${this.modalNamespace}${modalMutations.SET_MODAL_VISIBILITY_FALSE}`);
                })
                .catch(e => {
                    this.$store.commit(`${this.modalNamespace}${modalMutations.SELECT_MESSAGING_MODAL}`, {
                        header: 'an error happened',
                        message: e
                    });
                });
        }

        get showServicesModal(): boolean {
            return this.$store.getters[`${this.modalNamespace}isServicesVisible`];
        }

        /*
        * select service or doctor. Redirects to AppointmentSelect on click
        * */
        selectService(service: number) {
            this.closeModal();
            this.$router.push({path: '/appointment', query: {service: service.toString()}});
        }

        selectDoctor(doctor: number) {
            this.closeModal();
            this.$router.push({path: '/appointment', query: {doctor: doctor.toString()}});
        }

        closeModal() {
            this.$store.commit(`${this.modalNamespace}${ModalMutations.SET_SEARCH_MODAL_VISIBILITY_FALSE}`);
        }

        // Which tab to show
        show(name: string) {
            if (name === 'services') {
                this.showDoctors = false;
                this.showServices = true;
            } else if (name === 'doctors') {
                this.showServices = false;
                this.showDoctors = true;
            }
        }

        /*
* Filter entry point. Receives an event with current HTML node.
* Launches settimeout to prevent filtering everything on each node update
* */
        filter(e: any) {
            if (e.currentTarget.value === null) {
                this.doctorsListFiltered = this.doctorsList;
                this.servicesListFiltered = this.servicesList;
                return;
            }
            const value = e.currentTarget.value;
            const methodName = e.currentTarget.dataset.name + 'FilterList';
            setTimeout(() => this.filterSelector(value, methodName), 500);
        }

        // select custom filter
        filterSelector(value: string, method: string): any {
            this[method as keyof ModalServicesList](value);
        }

        doctorsFilterList(value: string) {
            this.doctorsListFiltered = [];
            return this.doctorsList.forEach((item) => {
                if (item.DoctorDisplayName.toLowerCase().indexOf(value.toLowerCase()) > -1) this.doctorsListFiltered.push(item);
            })
        }

        servicesFilterList(value: string) {
            this.servicesListFiltered = [];
            return this.servicesList.forEach((item) => {
                if (item.name.toLowerCase().indexOf(value.toLowerCase()) > -1) this.servicesListFiltered.push(item);
            })
        }
    }
